import { SternumTheme } from '@sternum/theme';
import { PaginationTheme } from '@sternum/ui';

import { Colors } from '../constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SBOMLightPaginationTheme(theme: SternumTheme): Partial<PaginationTheme> {
  return {
    backgroundColor: 'none',
    hoverBorder: 'none',
    textColor: Colors.DarkerText,

    arrowBorder: 'none',
    arrowTextColor: Colors.DarkerText,

    selectedBackgroundColor: 'none',
    selectedBorder: 'none',
    selectedTextColor: Colors.BrandPink,

    disabledBorder: 'none',
    disabledTextColor: Colors.GreyDarkerMiddle,
  };
}
